import { render, staticRenderFns } from "./CreateContactActivity.vue?vue&type=template&id=52cf342f&"
import script from "./CreateContactActivity.vue?vue&type=script&lang=js&"
export * from "./CreateContactActivity.vue?vue&type=script&lang=js&"
import style0 from "./CreateContactActivity.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports